import { GraphQLSnippet } from 'modules/snippets/types';
import { isDefined } from 'utils/tsHelpers';
import { getHasSnippets } from './getHasSnippets';
import { FetchSnippetQueryResponse } from '../../../hooks/useSnippets';

export const updateInsertSnippetModalState =
  (cb: (snippets: GraphQLSnippet[]) => void) => (response: FetchSnippetQueryResponse) => {
    const {
      fetchSnippets: { results },
    } = response;
    const hasSnippets = getHasSnippets(results);
    if (isDefined(results) && hasSnippets) cb(results);
  };
